import React from 'react';
import { aboutBg } from '../constants/assets';

export default function AboutSection() {
  return (
    <section className="z-0 bg-avaris-orange relative flex w-full min-h-[752px] flex-col items-center justify-center gap-7 p-8">
      {/* Decorative top-left element */}
      <img
        src={aboutBg}
        alt=""
        loading="lazy"
        className="z-0 pointer-events-none absolute left-[50px] top-0 h-32 w-[512px]"
      />

      <div className="relative flex flex-col gap-4 items-center justify-end w-full max-w-[1112px] text-black">
        <p className="font-trispace type-section-label w-full">About Avaris</p>

        <div className="flex flex-wrap gap-6 items-start w-full">
          {/* Headline */}
          <h2 className="font-trispace type-h1 w-full lg:w-[714px] lg:shrink-0">
            We are a small team that builds like a large one — minus the overhead, and without compromise.
          </h2>

          {/* Body copy */}
          <div className="flex-1 min-w-[220px] font-trispace type-body1 text-black">
            <p className="mb-4">
              Avaris AS is an AI-driven product development company based in Norway. We were founded
              on a straightforward premise: that years of domain expertise, combined with the right AI
              tools, enable a focused team to outperform organisations many times their size.
            </p>
            <p className="mb-4">
              We care deeply about craftsmanship. About software that performs, scales, and endures.
              And about building things that genuinely move the needle for the people who use them.
            </p>
            <ul className="list-disc pl-6 space-y-0">
              <li>Expertise-led, AI-amplified</li>
              <li>End-to-end ownership — from conception to deployment</li>
              <li>Focused on outcomes, not just deliverables</li>
              <li>Long-term thinking in every technical decision</li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
